export default "__VITE_ASSET__B7Xsgj7G__"